import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Calendar, Sparkles, Ticket } from "lucide-react";
import { BOTTOM } from "@/constants/testIds";
import { PORTES_OUVERTES_URL, INSCRIPTIONS_URL } from "@/lib/data";

export default function MobileBottomBar() {
  const location = useLocation();
  if (location.pathname.startsWith("/admin")) return null;
  return (
    <div
      data-testid={BOTTOM.bar}
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-xl border-t border-black/5"
    >
      <div className="grid grid-cols-3">
        <Link to="/planning" data-testid={BOTTOM.planning} className="flex flex-col items-center py-2.5 text-[11px] text-neutral-800 hover:text-[var(--he-red)]">
          <Calendar className="w-5 h-5 mb-1" /> Planning
        </Link>
        <a href={PORTES_OUVERTES_URL} target="_blank" rel="noreferrer" data-testid={BOTTOM.essai} className="flex flex-col items-center py-2.5 text-[11px] text-neutral-800 hover:text-[var(--he-red)]">
          <Sparkles className="w-5 h-5 mb-1" /> Essai
        </a>
        <a
          href={INSCRIPTIONS_URL}
          target="_blank"
          rel="noreferrer"
          data-testid={BOTTOM.inscription}
          className="flex flex-col items-center py-2.5 text-[11px] bg-[var(--he-red)] text-white font-bold uppercase tracking-wider"
        >
          <Ticket className="w-5 h-5 mb-1" /> Inscription
        </a>
      </div>
    </div>
  );
}
